import Provider from "./contracts/Provider";

export default class ProviderImpl implements Provider {

    private id: string | number = "";
    private name: string = "";
    private iconUrl: string | null = null;

    getId(): string | number {
        return this.id;
    }    
    getName(): string {
        return this.name;
    }

    getIconUrl(): string | null {
        return this.iconUrl;
    }
    setId(value: string | number): Provider {
        this.id = value;
        return this;
    }
    setName(value: string): Provider {
        this.name = value;
        return this;
    }
    setIconUrl(value: string): Provider {
        this.iconUrl = value;
        return this;
    }
}